import { z } from 'zod';
import {
    CloverReconciliationLookupOutcome,
    type CloverReconciliationLookupRequest,
    type CloverReconciliationLookupRequestDetails,
    type CloverReconciliationLookupResponseDetails,
    type CloverReconciliationLookupResult,
} from '../../../types/ipg/clover/clover-reconciliation.types';
import {
    CloverTransactionStatusRequestDetailsSchema,
    CloverTransactionStatusResponseDetailsSchema,
} from './clover-transaction-status.schemas';
import { JsonNonnegativeLosslessNumberInputSchema } from '../../common.schemas';

export const CloverReconciliationLookupRequestSchema: z.ZodType<CloverReconciliationLookupRequest> =
    z.object({
        merchant_transaction_id: z.string().min(1),
        settlement_date: z.string().min(1).optional(),
    });

export const CloverReconciliationLookupRequestDetailsSchema: z.ZodType<CloverReconciliationLookupRequestDetails> =
    z.object({
        statusRequestDetails: CloverTransactionStatusRequestDetailsSchema,
        lookup: CloverReconciliationLookupRequestSchema,
    });

export const CloverReconciliationLookupResultSchema: z.ZodType<CloverReconciliationLookupResult> =
    z.object({
        gateway_txn_id: z.string().min(1),
        merchant_transaction_id: z.string().min(1),
        is_settled: z.boolean(),
        batched_amount: JsonNonnegativeLosslessNumberInputSchema.optional(),
        gateway_batch: z.string().min(1).optional(),
        settlement_status: z.string().min(1).optional(),
        authorization_code: z.string().min(1).optional(),
    });

export const CloverReconciliationLookupResponseDetailsSchema: z.ZodType<CloverReconciliationLookupResponseDetails> =
    z.discriminatedUnion('outcome', [
        z.object({
            outcome: z.literal(CloverReconciliationLookupOutcome.AVAILABLE),
            httpStatus: z.literal(200),
            transactionStatusResponseDetails: CloverTransactionStatusResponseDetailsSchema,
            normalizedResult: CloverReconciliationLookupResultSchema,
        }),
        z.object({
            outcome: z.literal(CloverReconciliationLookupOutcome.UNAVAILABLE),
            httpStatus: z.number().int().positive(),
            transactionStatusResponseDetails: CloverTransactionStatusResponseDetailsSchema,
            message: z.string().min(1),
        }),
        z.object({
            outcome: z.literal(CloverReconciliationLookupOutcome.MALFORMED_RESPONSE),
            httpStatus: z.number().int().positive(),
            transactionStatusResponseDetails: CloverTransactionStatusResponseDetailsSchema,
            message: z.string().min(1),
        }),
    ]);
